export interface IActivity {
    eventCode: string;
    eventStartDate: string;
    eventEndDate: string;
    eventDateDescription?: string;
    registrationDate: string;
    eventArchiveDate?: string;
    dateAfterUserCannotRegisterAnymore?: string;
    dateAfterUserCannotCancelAnymore?: string;
    alwaysShowEventRegistration?: boolean;
    onlineEventStartDateTime?: string;
    eventWatchableUntil?: string;
    locationDescription?: string;
    registeredEventModificationUrl?: string;
    didRegister: boolean;
    title: string;
    description: string;
    informationUrl?: string;
    registrationUrl: string;
    calendarUrl?: undefined | string;
    routeUrl?: undefined | string;
    locationUrl?: undefined | string;
    cancellationUrl: string;
    surveyUrl?: string;
    surveyCompleted: boolean;
    surveyStartDate?: undefined | string;
    surveyEndDate?: undefined | string;
    participationUrl?: undefined | string;
    eventStudyType: string;
    isOnline: boolean;
}

export type IActivities = IActivity[]

export enum ActionButtonView {
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large"
}
